import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getParts({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQuerystring({
			partNo: searchParams.partNo,
			partName: searchParams.partName,
			cpnyCd: searchParams.cpnyCd || searchParams.cpnyNm,
			lastYn: searchParams.lastYn,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/comm/commpopup/partMngPopup/v1/pqParts${queryStr}`);
			return response && response.data;
		} catch (error) {
			throw error?.response?.data;
		}
	}
};
